module.exports = __webpack_public_path__ + "img/logo-partnership1.5548ced1.png";